// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type WorkspaceFeatureDecisionsQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['ID']['input'];
}>;


export type WorkspaceFeatureDecisionsQuery = { __typename?: 'Query', workspaceFeatureDecisions: Array<{ __typename?: 'EvaluatedFeatureDecision', key: string, label: string, description?: string | null, enabled: boolean, effectiveValue?: string | null, isWorkspaceConfigurable: boolean, isPubliclyVisible: boolean, reason: string, workspaceOverride: boolean }> };


export const WorkspaceFeatureDecisionsDocument = gql`
    query WorkspaceFeatureDecisions($workspaceId: ID!) {
  workspaceFeatureDecisions(workspaceId: $workspaceId) {
    key
    label
    description
    enabled
    effectiveValue
    isWorkspaceConfigurable
    isPubliclyVisible
    reason
    workspaceOverride
  }
}
    `;

/**
 * __useWorkspaceFeatureDecisionsQuery__
 *
 * To run a query within a React component, call `useWorkspaceFeatureDecisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceFeatureDecisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceFeatureDecisionsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useWorkspaceFeatureDecisionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspaceFeatureDecisionsQuery, WorkspaceFeatureDecisionsQueryVariables> & ({ variables: WorkspaceFeatureDecisionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceFeatureDecisionsQuery, WorkspaceFeatureDecisionsQueryVariables>(WorkspaceFeatureDecisionsDocument, options);
      }
export function useWorkspaceFeatureDecisionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceFeatureDecisionsQuery, WorkspaceFeatureDecisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceFeatureDecisionsQuery, WorkspaceFeatureDecisionsQueryVariables>(WorkspaceFeatureDecisionsDocument, options);
        }
// @ts-ignore
export function useWorkspaceFeatureDecisionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceFeatureDecisionsQuery, WorkspaceFeatureDecisionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceFeatureDecisionsQuery, WorkspaceFeatureDecisionsQueryVariables>;
export function useWorkspaceFeatureDecisionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceFeatureDecisionsQuery, WorkspaceFeatureDecisionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceFeatureDecisionsQuery | undefined, WorkspaceFeatureDecisionsQueryVariables>;
export function useWorkspaceFeatureDecisionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceFeatureDecisionsQuery, WorkspaceFeatureDecisionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspaceFeatureDecisionsQuery, WorkspaceFeatureDecisionsQueryVariables>(WorkspaceFeatureDecisionsDocument, options);
        }
export type WorkspaceFeatureDecisionsQueryHookResult = ReturnType<typeof useWorkspaceFeatureDecisionsQuery>;
export type WorkspaceFeatureDecisionsLazyQueryHookResult = ReturnType<typeof useWorkspaceFeatureDecisionsLazyQuery>;
export type WorkspaceFeatureDecisionsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceFeatureDecisionsSuspenseQuery>;
export type WorkspaceFeatureDecisionsQueryResult = ApolloReactCommon.QueryResult<WorkspaceFeatureDecisionsQuery, WorkspaceFeatureDecisionsQueryVariables>;